import { Box } from '@chakra-ui/react';
import { FC } from 'react';

import 'video.js/dist/video-js.css';
import { IVideoJSProps } from '@/hooks/videojs/type';
import { useVideoJs } from '@/hooks/videojs/use-videojs';

export const VideoJSCore: FC<IVideoJSProps> = ({
  options,
  crossOrigin,
  onPlay,
  onResume,
  onPause,
  onEnded,
  onSourceChange,
  onDispose,
  onReady,
  onTextTracksChange,
  ...rest
}) => {
  const videoRef = useVideoJs({
    onPlay,
    onResume,
    onPause,
    onEnded,
    onSourceChange,
    onDispose,
    onReady,
    onTextTracksChange,
    options,
    crossOrigin,
  });

  return (
    <Box data-vjs-player w="full" {...rest}>
      <Box ref={videoRef} />
    </Box>
  );
};
